export { ApiClientError } from './ApiClientError';
export { ApiServerError } from './ApiServerError';
export { ApiRequestCancelError } from './ApiRequestCancelError';
export { ApiConnectionError } from './ApiConnectionError';

// eslint-disable-next-line no-shadow
export enum ResponseCode {
  SUCCESS = 200,
  BAD_REQUEST = 400,
  APIUNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  VALIDATION_ERROR = 422,
}

/**
 * バリデーションエラー
 */
export interface ValidationError {
  field: string,
  message: string
}
